module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_square_chestnut.48a58cac.png";